module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAASVl2WAAAAAXNSR0IArs4c6QAAAORJREFUKFNt0LtOAzEQheF/niWmollHSHFegltPExBlQhoQBUhQAUVElDJQINEDoqWP06zTr/Msg7wiCLN7yuNPHo/Fl/EKYcdZs0dL5Afcispnr9vZ/W8kFT6sR6CPwLuz5uAvqkHKooxDEabAh7Nmf9P/glQsV9VYVSYKb31rDlOXgRqFeK5wD/LqbOeoAWpUVscq8gR8tQK/qm5QuVZ4aQBfVs+IDBC9c8XWZQZ8iGnVETB11pxlj1yGOFc4UXjoW3ORrbkI64mgYxFmvcIMs4/aXNt2WI/wIZ4ibLvCpNmNfAOyVk9PlSNIGQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiangyou01.png
// module id = P4dU
// module chunks = 1